import { render, staticRenderFns } from "./ProductionDashboard.vue?vue&type=template&id=376bde32&"
import script from "./ProductionDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProductionDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports